/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {Directive, HostListener, Input, OnInit, Renderer2} from '@angular/core';

import {ModalService} from './modal.service';

/**
 * Link that opens a modal with passed identifier
 *
 * Usage:
 *
 * ```
 * <div gp-open-modal='signin'>Sign-in</div>
 * ```
 */
@Directive({
  selector: '[gp-open-modal]'
})
export class OpenModalDirective implements OnInit {

  private _modalId: string;

  private _modalName: string;

  @Input() set modalId(id: string) {
    this._modalId = id;
  }

  @Input() set modalName(name: string) {
    this._modalName = name;
  }

  constructor(
    private modalService: ModalService,
    private renderer: Renderer2
  ) {

  }

  public ngOnInit() {
    this.modalService.modalOpened.subscribe((modal: string) => {
      if (modal === this._modalId || modal === this._modalName) {
        this.renderer.addClass(document.body, 'modal-open');
      }
    });

    this.modalService.modalClosed.subscribe((modal: string) => {
      if ((modal === this._modalId || modal === this._modalName) && !this.modalService.modalWithIdOpen.length) {
        this.renderer.removeClass(document.body, 'modal-open');
      }
    });
  }

  @HostListener('click')
  public onClick() {
    if (this._modalId !== undefined) {
      this.modalService.openModalWithId(this._modalId);
    } else if (this._modalName !== undefined) {
      this.modalService.openModalWithName(this._modalName);
    } else {
      throw new Error('No modal id or component passed !');
    }
  }
}
